import { InputBase } from '~/InputBase';
import getCities from '../api/getCities';
import { withAutocomplete } from './withAutocomplete';

/** @type {import('~/Autocomplete').AutocompleteDataset} */
const dataset = {
	name: 'default',
	source: (query, cb) => {
		getCities(query)
			.then(cb)
			.catch(reason => {
				console.log(reason);
				cb([]);
			});
	},
	displayKey: (suggestion) => suggestion.toString(),
	templates: {
		suggestion: (suggestion) => suggestion.toString(),
	},
	debounce: 350,
	cache: true,
}

export const InputCityAutocomplete = {
	name: 'InputCityAutocomplete',
	extends: InputBase,
	mixins: [
		withAutocomplete([dataset]),
	],
}
